<template>
    <div class="jf_container">
        <myTab :tabData="tabData" @tab_index="handleTabIndex"></myTab>
        <div class="jf_conditionBox">
            <mySearch
                class="my-search"
                @searchData="searchData"
                :paramData="searchParam"
                searchApi="point_check/index"
                v-model="searchContent"
            ></mySearch>
            <el-date-picker
                class="picker"
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchParam.date=date;getMyList()"
            ></el-date-picker>
            <button class="createBtn" @click="showAddBox=1">新增</button>
        </div>
        <el-table class="elTable" :data="tableData">
            <el-table-column
                prop="typename"
                label="积分分类"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_name"
                label="规则名称"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_des"
                label="积分细则"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="content"
                label="申请说明"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="奖惩分数" align="center">
                <template slot-scope="scope">
                    <span
                        :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}"
                    >{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标准分数" align="center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="check_time"
                label="申请日期"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="附件" header-align="center">
                <template slot-scope="scope">
                    <a
                        :href="scope.row.file"
                        :download="scope.row.file_name"
                        v-if="scope.row.file"
                        target="_Blank"
                    >
                        <span style="color:#E6BE8A">查看</span>
                        <!-- <img width="30" src="/static/qmsj/img/jifen/file.jpg" alt /> -->
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                label="驳回理由"
                align="center"
                :show-overflow-tooltip="true"
                v-if="tabIndex==2"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.reason">{{scope.row.reason}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" v-if="tabIndex===0">
                <template slot-scope="scope">
                    <el-button
                        @click="showDialog(scope.row)"
                        type="text"
                        size="small"
                        style="color:#E6BE8A"
                    >编辑</el-button>
                    <el-button
                        @click="cancel(scope.row.id)"
                        type="text"
                        size="small"
                        style="color:#ff5454"
                    >撤销</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <p
            class="pageTotal"
        >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
        <el-pagination
            class="pageBody"
            @current-change="getMyList(1)"
            :current-page.sync="pageData.page"
            background
            layout="prev, pager, next"
            :total="pageData.count*1"
        ></el-pagination>

        <!-- 撤销弹窗 -->
        <el-dialog class="elDialog" :visible.sync="cancelVisible" width="350" :show-close="false">
            <span class="tip">确认要撤销此项积分申请吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelVisible = false">取 消</el-button>
                <el-button type="warning" @click="handleVerify">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 积分申请 -->
        <div class="myDialog" v-if="showAddBox>0">
            <div class="myDialog_content shenqing-myDialog_content">
                <h4 class="myDialog_h">
                    {{showAddBox==1?'积分申请':'编辑申请'}}
                    <i
                        class="close el-icon-circle-close-outline"
                        @click="resetData()"
                    ></i>
                </h4>
                <!-- <div class="inp_wrap inline_inp">
                    <label>积分分类:</label>
                    <el-select
                        v-model="parentAssortId"
                        placeholder="请选择分类"
                        @change="choosechildAssortArr"
                    >
                        <el-option
                            v-for="item in assortArray"
                            :key="item.id+1000"
                            :label="item.typename"
                            :value="item.id"
                            :disabled="item.pid==0"
                        >
                            <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                        </el-option>
                    </el-select>
                </div> -->
                <!-- <div class="inp_wrap inline_inp">
                    <label>规则名称:</label>
                    <el-select
                        v-model="childAssortId"
                        placeholder="请选择规则"
                        @change="handleChangeRule"
                    >
                        <el-option
                            v-for="item in childAssortArr"
                            :key="item.id+1200"
                            :label="item.rule_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div> -->
                <div class="inp_wrap">
                    <label>规则名称:</label>
                    <el-autocomplete
                        style="width:200px!important"
                        v-model="childAssortName"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入规则名称"
                        @select="handleChangeRule"
                    ></el-autocomplete>
                </div>
                <div class="inp_wrap">
                    <label>积分细则:</label>
                    <div class="xizeBox" style="padding:6px" v-text="rule_des"></div>
                </div>
                <div class="inp_wrap">
                    <label>申请说明:</label>
                    <el-input
                        class="xizeBox"
                        style="border:none"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        resize="none"
                        v-model.trim="content"
                    ></el-input>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>申请时间:</label>
                    <el-date-picker
                        v-model="eventTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>申请分数:</label>
                    <el-input
                        type="number"
                        v-model="applyScore"
                        :disabled="score_type==1?true:false"
                    ></el-input>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>附件上传:</label>
                    <label class="uploadBtn" for="upload">请点击选择</label>
                    <input
                        id="upload"
                        type="file"
                        @change="handleUpload($event)"
                        name="file_upload"
                    />
                </div>
                <p class="fileName" v-if="fileName">
                    <i class="el-icon-document"></i>
                    {{fileName}}
                    <i class="el-icon-check"></i>
                </p>

                <div class="btnWrap">
                    <button class="assort_confim-btn" @click="showAddBox=0">返回</button>
                    <button class="assort_confim-btn confim" @click="addApply">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myTab from "../../components/myTab.vue";
import mySearch from "../../components/mySearch.vue";
var baseUrl = process.env.apiUrl + "point/";

export default {
    data() {
        return {
            cancelVisible: false,
            tabData: ["未审核", "已通过", "未通过"],
            tabIndex: 0,
            date: [],
            fileName: null,
            // ----------------
            showAddBox: 0, // 显示新增弹窗  0-关闭 1-增加 2-编辑
            token: "",
            assortArray: [],
            parentAssortId: "",
            childAssortArr: [],
            childAssortId: "",
            eventTime: "",
            applyScore: "",
            content: "",
            filePath: "",
            rule_des: "",
            rule_type: 1, // 1-加分 ，2-减分
            score_type: 1, // 1-固定 ，2-返回
            score_max: "",
            score_min: "",
            activeRuleId: "",
            tableData: [],
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            activeId: "",
            searchParam: {
                from: 2,
                date: "",
                shenhe: 1
            },
            searchContent: "",
            childAssortName: ''
        };
    },
    created() {
        this.token = this.$cookies.get("token");
        this.getMyList();
        this.getAssortList();
    },
    components: {
        myTab,
        mySearch
    },
    methods: {
        handleTabIndex(data) {
            this.tabIndex = data;
            this.searchParam.shenhe = data * 1 + 1;
            this.date = "";
            this.searchContent = "";
            this.getMyList();
        },
        // ----------------
        // 列表
        async getMyList(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_check/index", {
                    token: that.token,
                    from: 2, //  1 考核列表  2.个人申请列表 3.审核列表
                    shenhe: that.tabIndex + 1, // 1.未审核 2.审核通过  3.审核驳回
                    time_s:
                        that.date && that.date.length > 0 ? that.date[0] : "",
                    time_e:
                        that.date && that.date.length > 0 ? that.date[1] : "",
                    search: that.searchContent,
                    page: that.pageData.page
                });
                if (res.status === 1) {
                    that.tableData = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page*1;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.status == 1) {
                    if (res.data && res.data.length > 0) {
                        that.assortArray = [];
                        res.data.forEach((element, index) => {
                            that.assortArray.push({
                                typename: element.typename,
                                pid: element.pid,
                                id: element.id
                            });
                            if (element.child && element.child.length > 0) {
                                element.child.forEach((ele, i) => {
                                    that.assortArray.push({
                                        typename: ele.typename,
                                        pid: ele.pid,
                                        id: ele.id
                                    });
                                });
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取规则列表
        async choosechildAssortArr(type) {
            if (type != "edit") {
                // 点击编辑时传入 edit
                this.childAssortId = "";
                this.rule_des = "";
                this.applyScore = "";
            }
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_rule/index", {
                    token: that.token,
                    typeid: that.parentAssortId
                });
                if (res.status == 1) {
                    that.childAssortArr = res.data;
                    if (type == "edit") {
                        // 编辑时 获取分数类型和范围
                        res.data.forEach(ele => {
                            if (that.childAssortId == ele.id) {
                                that.score_type = ele.score_type;
                                if (ele.score_type == 2) {
                                    that.score_max = ele.score_max;
                                    that.score_min = ele.score_min;
                                } else {
                                    that.applyScore = ele.score;
                                }
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        handleUpload(e) {
            var isIE = /msie/i.test(navigator.userAgent) && !window.opera;
            var fileSize = 0;
            if (isIE && !e.target.files) {
                // IE浏览器
                var filePath = e.target.value; // 获得上传文件的绝对路径
                var fileSystem = new ActiveXObject(
                    "Scripting.FileSystemObject"
                );
                // GetFile(path) 方法从磁盘获取一个文件并返回。
                var file1 = fileSystem.GetFile(filePath);
                fileSize = file1.Size; // 文件大小，单位：b
            } else {
                // 非IE浏览器
                fileSize = e.target.files[0].size;
            }
            if (fileSize / 1024 / 1024 > 3) {
                this.$message.warning("附件不能大于3M");
                return;
            }
            let that = this;
            let file = e.target.files[0];

            let param = new FormData(); //创建form对象
            param.append("file", file); //通过append向form对象添加数据
            param.append("token", that.token); //通过append向form对象添加数据

            $.ajax({
                url: baseUrl + "point_check/upload_file",
                type: "post",
                data: param,
                contentType: false,
                processData: false,
                dataType: "json",
                success: function(res) {
                    if (res.status == 1) {
                        that.filePath = res.file;
                        that.fileName = file.name;
                    }
                },
                fail: function(err) {
                    that.$message.error(err);
                }
            });
        },
        // 选择规则后触发
        // handleChangeRule() {
        //     this.applyScore = "";
        //     this.childAssortArr.forEach(ele => {
        //         if (ele.id == this.childAssortId) {
        //             this.rule_des = ele.rule_des;
        //             this.rule_type = ele.rule_type;
        //             this.score_type = ele.score_type;
        //             if (ele.score_type == 2) {
        //                 this.score_max = ele.score_max;
        //                 this.score_min = ele.score_min;
        //             } else {
        //                 this.applyScore = ele.score;
        //             }
        //             return;
        //         }
        //     });
        // },
        handleChangeRule(item) {
            this.childAssortId = item.id
            this.applyScore = "";
            this.rule_des = item.rule_des;
            this.rule_type = item.rule_type;
            this.score_type = item.score_type;
            if (item.score_type == 2) {
                this.score_max = item.score_max;
                this.score_min = item.score_min;
            } else {
                this.applyScore = item.score;
            }
        },
        // 新增
        async addApply() {
            // if (this.parentAssortId == "") {
            //     this.$message.error("请选择分类");
            //     return;
            // }
            if (this.childAssortId == "") {
                this.$message.error("请从实时搜索结果中选择规则名称");
                return;
            }
            if (this.content == "") {
                this.$message.error("请输入申请说明");
                return;
            }
            if (this.eventTime == "") {
                this.$message.error("请选择日期");
                return;
            }
            if (this.applyScore == "") {
                this.$message.error("请输入申请分数");
                return;
            }
            if (
                this.score_type == 2 &&
                (this.applyScore < this.score_min*1 ||
                    this.applyScore > this.score_max*1)
            ) {
                this.$message.error("申请分数超出范围");
                return;
            }
            let that = this;
            let url =
                this.showAddBox == 1 ? "point_check/add" : "point_check/update";
            try {
                let res = await that.$http.post(baseUrl + url, {
                    token: that.token,
                    from: 2,
                    check_time: that.eventTime,
                    rule_id: that.childAssortId,
                    score: that.applyScore,
                    content: that.content,
                    rule_type: that.rule_type,
                    file: that.filePath,
                    file_name: that.fileName,
                    id: that.showAddBox == 2 ? that.activeRuleId : null
                });
                if (res.status == 1) {
                    that.$message.success(res.msg);
                    that.getMyList();
                    that.resetData();
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        searchData(data) {
            this.tableData = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        // 编辑
        showDialog(item) {
            this.childAssortName = item.rule_name
            this.showAddBox = 2;
            this.activeRuleId = item.id;
            this.eventTime = item.check_time;
            this.childAssortId = item.rule_id;
            this.applyScore = item.score;
            this.content = item.content;
            this.rule_type = item.rule_type;
            this.filePath = item.file;
            this.rule_des = item.rule_des;
            this.parentAssortId = item.type_id;
            this.fileName = item.file_name;
            this.choosechildAssortArr("edit");
        },
        // 撤销弹窗按钮
        cancel(id) {
            this.cancelVisible = true;
            this.activeId = id;
        },
        // 关闭弹窗时 重置数据
        resetData() {
            this.showAddBox = 0;
            this.eventTime = "";
            this.childAssortId = "";
            this.applyScore = "";
            this.content = "";
            this.rule_type = "";
            this.filePath = "";
            this.rule_des = "";
            this.parentAssortId = "";
            this.childAssortArr = [];
            this.filePath = "";
            this.fileName = null;
            this.childAssortName = ''
        },
        // 撤销 请求函数
        async handleVerify() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/delete",
                    {
                        id: that.activeId
                    }
                );
                if (res.status == 1) {
                    that.$message.success("撤销成功");
                    that.getMyList();
                    that.cancelVisible = false;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 实时搜索 规则名称函数
        async querySearchAsync(queryString, cb) {
            this.childAssortId = ''
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_rule/search",
                    {
                        search: queryString
                    }
                );
                if (res.status == 1) {
                    let ret = []
                    if (res.data.length>0){
                        res.data.forEach(item => {
                            let obj = {}
                            obj = {...item}
                            obj.value = item.rule_name
                            ret.push(obj)
                        })
                    } else {
                        ret = [{'value': '暂无数据'}]
                    }
                    cb(ret);
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        }
    }
};
</script>
<style scoped>
.jf_container {
    min-width: 800px;
}
.jf_conditionBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    padding-left: 30px;
    background: #f5f5f5;
}
.elTable {
    width: 96%;
    margin: 20px 0 0 30px;
    text-align: center;
}
.assort {
    float: left;
}
.picker {
    float: left;
    margin-left: 20px;
}
.my-search {
    float: left;
}
.dialogText {
    border-radius: 4px;
    width: 280px;
    height: 90px;
    padding: 6px;
    outline: none;
    resize: none;
}
.shenqing-myDialog_content {
    width: 600px;
}
.createBtn {
    float: right;
    margin-right: 20px;
    outline: none;
    border: none;
    border-radius: 4px;
    width: 114px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    background: #E6BE8A;
}
.close {
    float: right;
    margin: 8px 20px;
}
.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #E6BE8A;
}
.inline_inp {
    display: inline-block;
}
.inp_wrap label {
    font-size: 15px;
}
.xizeBox {
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 416px;
    min-height: 40px;
    vertical-align: middle;
    font-size: 14px;
}
#upload {
    position: absolute;
    bottom: 0;
    right: 0;
    opacity: 0;
    width: 0;
    height: 0;
}
.uploadBtn {
    border-radius: 4px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #a3a3a6;
    background: #f1f1f1;
    cursor: pointer;
}
.fileName {
    display: inline-block;
    margin-left: 30px;
    height: 40px;
}
.el-icon-check {
    margin-left: 20px;
    font-size: 16px;
    font-weight: 600;
    color: green;
}
.secondary {
    margin-left: 30px;
}
</style>
<style>
    .shenqing-myDialog_content .el-autocomplete .el-input {
        width: 200px!important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/jifen/shenqing.vue